import { Button } from '@app/src/common/Button';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

interface Props {
  isRecommend?: boolean;
}

export const Wrapper = styled.article`
  background: #fff;
  border: 1px solid ${COLORS.GRAY};
  border-radius: 5px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK};
  font-size: 13px;
  width: 280px;
  position: relative;

  ${(props: Props) => props.isRecommend && `
    &:after {
      content: '¡recomendado!';
      text-transform: uppercase;
      color: #fff;
      font-family: ${FONTS.ROBOTO_BOLD};
      font-size: 11px;
      background: ${COLORS.RED_HIGHLIGHT};
      line-height: 31px;
      padding: 0 17px;
      position: absolute;
      border-radius: 5px;
      top: -31px;
      left: 50%;
      transform: translateX(-50%);
    }
    &:before {
      content: '';
      border-top: 9px solid ${COLORS.RED_HIGHLIGHT};
      border-right: 9px solid transparent;
      border-left: 9px solid transparent;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0;
    font-size: 16px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  margin-top: 20px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 36px;
  }
`;

export const Subtitle = styled.h3`
  font-size: 13px;
  color: ${COLORS.BLUE_LINK};
  font-weight: 400;
  margin-top: 4px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 15px;
  }
`;

export const Discount = styled.span`
  font-size: 13px;
  line-height: 24px;
  padding: 0 16px;
  display: inline-block;
  background: ${COLORS.YELLOW_HIGHLIGHT};
  margin-top: 10px;
`;

export const PriceTotal = styled.p`
  text-transform: uppercase;
  font-size: 14px;
  margin-top: 6px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
  }
`;

export const Number = styled.span`
  font-size: 20px;
  font-family: ${FONTS.ROBOTO_BOLD};
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 28px;
  }
`;

export const Decimal = styled.span`
  font-size: 11px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const PriceRegular = styled.span`
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
`;

export const Separator = styled.div`
  width: 232px;
  border-top: 1px solid ${COLORS.GRAY};
  margin: 16px auto;
`;

export const List = styled.ul`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 14px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const Item = styled.li`
  &:not(:last-child):after {
    content: '+';
    margin: 0 4px;
  }
`;

export const Channel = styled.span`
  font-family: ${FONTS.ROBOTO};
  font-size: 12px;
`;

export const HighLights = styled.p`
  font-size: 13px;
  margin: 16px 0 6px;
  color: ${COLORS.GRAY_DARK};
`;

export const ListHigh = styled.ul``;

export const ItemHigh = styled.li``;

export const Count = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
`;

export const ButtonContract = styled(Button)`
  margin: 24px auto;
`;